// P2 Faz 1 — sol menüdeki "Performans Gelen Kutum" rozetinin saf kuralları (spec
// §Bileşen 3: "sol menüde bekleyen iş sayısı rozeti"). Axios İMPORT ETMEZ:
// hook dosyasından ayrı durur ki testi CRA5'in axios ESM sorununa hiç girmesin
// (bkz. SmartStatsRow.test.js yorumu).

export const INBOX_PATH = '/performance/inbox';

// 99'dan sonrası "99+" — rozet menü öğesini taşırmasın.
export const MAX_BADGE = 99;

// Gelen kutusu sayfası her çekişte kesin sayıyı bu olayla yayınlar; rozet
// (60 sn önbellekli sayaç ucundan beslenir) onu anında benimser.
export const INBOX_COUNT_EVENT = 'performance-inbox:count';

// Rozet her rota değişiminde değil, sayıyı DEĞİŞTİREBİLECEK bir sayfadan
// çıkarken tazelenir: performans/yetenek/geri bildirim yüzeylerindeki her
// onay/red/doldurma işlemi bekleyen iş sayısını düşürür. Menüde gezinen
// kullanıcı için gereksiz istek üretmemek adına kapsam bu üç önekle sınırlı.
const REFRESHING_PREFIXES = ['/performance/', '/talent/', '/feedback/'];

export function shouldRefreshInboxBadge(prevPath, nextPath) {
  if (!prevPath || prevPath === nextPath) return false;
  return REFRESHING_PREFIXES.some((prefix) => prevPath.startsWith(prefix));
}

// Rozet sayısı, gelen kutusu listesinin uzunluğudur — ayrı bir sayaç ucu YOK,
// iki kaynak arasında tutarsızlık doğamaz. 0/negatif → rozet hiç çizilmez.
export function formatBadgeCount(count) {
  if (!count || count < 1) return null;
  return count > MAX_BADGE ? `${MAX_BADGE}+` : String(count);
}
